module.exports = __webpack_public_path__ + "img/violet_109.097fde89.png";